// ----------------------------------------------------------------------------
// Progress loading
// ----------------------------------------------------------------------------

import macro from '@kitware/vtk.js/macros';
var mycontainer;
var progressContainer;

class vxVtkProgress {
    static init(vtkModel) {
        mycontainer = vtkModel.container.parentElement;
        progressContainer = document.createElement('div');
        progressContainer.setAttribute('class', 'vtkprogress');
        const dims = vtkModel.container.getBoundingClientRect();
        progressContainer.style.height = Math.floor(dims.height);
        //.setSize(Math.floor(dims.width,Math.floor(dims.height);
        mycontainer.insertBefore(progressContainer, vtkModel.container);
    }
    static progressCallback(progressEvent) {
        if (progressEvent.lengthComputable) {
            const percent = Math.floor(
                (100 * progressEvent.loaded) / progressEvent.total
            );
            progressContainer.innerHTML = `Loading ${percent}%`;
        } else {
            progressContainer.innerHTML = macro.formatBytesToProperUnit(
                progressEvent.loaded
            );
        }
    };
    static hide() {
        mycontainer.removeChild(progressContainer);
    }
};

export default vxVtkProgress;